export enum Context {
  DIAGNOSIS = 'diagnosis',
  SCANNER = 'scanner',
  PRO = 'pro',
  REPORT = 'report',
  UNKNOWN = 'unknown'
}
